<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="helpCenterPermissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="helpCenterPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-envelopes-bulk"></i></span>{{ "UserGroupSubscriptionMaintenance.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="grid formgrid p-fluid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'UserGroupSubscriptionMaintenance.Form.NotifyEvent' | translate }}</label>
              <p-dropdown
                appendTo="body"
                formControlName="notifyEventGroupKey"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [options]="notifyEventOptions"
                filterBy="label"
                [showClear]="true"
                (onChange)="changeSearchFormWorkTypeOptions($event)">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'UserGroupSubscriptionMaintenance.Form.Tenant' | translate }}</label>
              <p-dropdown
                appendTo="body"
                formControlName="tenant"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [options]="searchFormTenantOptionsBySelectedGroup"
                filterBy="label"
                [filter]="true"
                [showClear]="true"
                (onChange)="changeTenant($event, 'searchForm')">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'UserGroupSubscriptionMaintenance.Form.Group' | translate }}</label>
              <div class="flex">
                <div style="width:90%">
                  <p-dropdown
                    appendTo="body"
                    formControlName="tenantMappingUserGroupSeqNo"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                    [options]="searchFormUserGroupOptionsBySelectedTenant"
                    filterBy="label"
                    [filter]="true"
                    [showClear]="true"
                    (onChange)="changeGroup($event, 'searchForm')">
                  </p-dropdown>
                </div>
                <div>
                  <button
                    pButton pRipple
                    type="button"
                    icon="far fa-hand-pointer"
                    [disabled]="!searchForm.value.tenantMappingUserGroupSeqNo"
                    (click)="showTenantMappingUserGroupDetailDialog(searchForm.value.tenantMappingUserGroupSeqNo, true)">
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="grid formgrid p-fluid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'UserGroupSubscriptionMaintenance.Form.WorkType' | translate }}</label>
              <p-dropdown
                appendTo="body"
                formControlName="workType"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [showClear]="true"
                [options]="searchFormWorkTypeOptionsBySelectedNotifyEvent"
                (onChange)="updateNotifyEventBySelectedWorkType($event, 'searchForm')">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'UserGroupSubscriptionMaintenance.Form.Brand' | translate }}</label>
              <p-multiSelect
                appendTo="body"
                formControlName="brands"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="brandOptions"
                [virtualScroll]="true"
                [itemSize]="40"
                [showToggleAll]="false">
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'UserGroupSubscriptionMaintenance.Form.Dept' | translate }}</label>
              <p-multiSelect
                appendTo="body"
                formControlName="depts"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="deptOptionsByPermission"
                [virtualScroll]="true"
                [itemSize]="40"
                [showToggleAll]="false">
              </p-multiSelect>
            </div>
          </div>
          <div class="grid formgrid p-fluid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'UserGroupSubscriptionMaintenance.Form.CreateUser' | translate }}</label>
              <p-dropdown
                appendTo="body"
                formControlName="createUser"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [showClear]="true"
                [options]="userOptions">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'UserGroupSubscriptionMaintenance.Form.UpdateUser' | translate }}</label>
              <p-dropdown
                appendTo="body"
                formControlName="updateUser"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [showClear]="true"
                [options]="userOptions">
              </p-dropdown>
            </div>
          </div>
          <div>
            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()">
            </button>
            <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" type="reset" (click)="resetBtnClick()"
                class="p-button-secondary ml-2"></button>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #headerTable
        [dataKey]="'rowId'"
        [tableKey]="preferenceKey"
        [value]="userGroupSubscriptionData"
        [defaultColumns]="userGroupSubscriptionColumns"
        [loading]="isLoading"
        [lazy]="true"
        [editPermission]="editPermissionCode"
        [createNewRow]="createNewRow"
        [inputValid]="dataInputValid"
        (createRow)="createRow($event)"
        (savedData)="saveData($event)"
        (restoreData)="restoreData()"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [isShowExportFunction]="true"
        [isShowImportFunction]="true"
        (exportData)="exportDataToExcel()"
        (importData)="importDataFromExcel($event)"
        (onRowSelect)="onRowSelect($event)">
        <ng-template pTemplate="caption">
          <ng-container >
            <button
              pButton
              type="button"
              label="{{ 'ReceivingRegistration.Button.TemplateDownload'| translate }}"

              (click)="templateDownloadBtn()"
              class="p-button-danger p-button-raised ml-2">
            </button>
          </ng-container>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'notifyEventGroupKey'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: this.notifyEventOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'tenantMappingUserGroupSeqNo'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: this.userGroupOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'tenant'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: this.tenantOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'orgId'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: this.orgIdOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'workType'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: this.workTypeOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'brand'" class="p-fluid">
                <div class="overflow-text">
                  <ng-container *ngIf="!rowData['workType']; else showData">
                    -
                  </ng-container>
                  <ng-template #showData>
                    <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                      ALL
                    </ng-container>
                    <ng-template #showData>
                      {{ rowData[col.field] | optionsMapping: this.brandOptions | replaceNullWith: "ALL" }}
                    </ng-template>
                  </ng-template>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'vendorCategory'" class="p-fluid">
                <div class="overflow-text">
                  <ng-container *ngIf="!rowData['workType']; else showData">
                    -
                  </ng-container>
                  <ng-template #showData>
                    <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                      ALL
                    </ng-container>
                    <ng-template #showData>
                      {{ rowData[col.field] | optionsMapping: this.vendorCategoryOptions | replaceNullWith: "ALL" }}
                    </ng-template>
                  </ng-template>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'dept'" class="p-fluid">
                <div class="overflow-text">
                  <ng-container *ngIf="!rowData['workType']; else showData">
                    -
                  </ng-container>
                  <ng-template #showData>
                    <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                      ALL
                    </ng-container>
                    <ng-template #showData>
                      {{ rowData[col.field] | optionsMapping: this.deptOptions | replaceNullWith: "ALL" }}
                    </ng-template>
                  </ng-template>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'consigneeKey'" class="p-fluid">
                <div class="overflow-text">
                  <ng-container *ngIf="rowData['workType'] && (rowData['workType'] === 'COMMON_DELIVERY_ORDER' || rowData['workType'] === 'TENANT_GROUP_TRANSFER_DELIVERY_ORDER'); else showDisableData">
                    <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                      ALL
                    </ng-container>
                    <ng-template #showData>
                      {{ rowData[col.field] | optionsMapping: this.customerOptions | replaceNullWith: "ALL" }}
                    </ng-template>
                  </ng-container>
                  <ng-template #showDisableData>
                    -
                  </ng-template>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'salesCode'" class="p-fluid">
                <div class="overflow-text">
                  <ng-container *ngIf="rowData['workType'] && (rowData['workType'] === 'COMMON_DELIVERY_ORDER' || rowData['workType'] === 'TENANT_GROUP_TRANSFER_DELIVERY_ORDER'); else showDisableData">
                    <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                      ALL
                    </ng-container>
                    <ng-template #showData>
                      {{ rowData[col.field] | optionsMapping: this.salesOptions | replaceNullWith: "ALL" }}
                    </ng-template>
                  </ng-container>
                  <ng-template #showDisableData>
                    -
                  </ng-template>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'isActivated'" class="p-fluid">
                <p-inputSwitch
                  class="ml-2"
                  [(ngModel)]="rowData.transIsActivated"
                  [disabled]="!editPermission"
                  (onChange)="changeActivated($event, rowData)">
                </p-inputSwitch>
              </ng-container>

              <ng-container *ngSwitchCase="'updateActivatedUser'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'updateUser'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'createUser'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault class="p-fluid">
                <ng-container [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'" class="p-fluid">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date : "yyyy-MM-dd" | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault class="p-fluid">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>

        <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'notifyEventGroupKey'" class="p-fluid">
              <p-dropdown
                appendTo="body"
                class="p-fluid"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="notifyEventOptionsBySelectedWorkType"
                [(ngModel)]="rowData[col.field]"
                (onChange)="getWorkTypeOptionsBySelectedNotifyEvent($event, rowData)">
              </p-dropdown>
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ 'Common.Button.Required' | translate }}
                </div>
              </small>
            </ng-container>

            <ng-container *ngSwitchCase="'tenantMappingUserGroupSeqNo'" class="p-fluid">
              <div class="flex">
                <div style="width:90%">
                  <p-dropdown
                    [style]="{'width':'100%'}"
                    appendTo="body"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                    [options]="userGroupOptionsBySelectedTenant"
                    [(ngModel)]="rowData[col.field]"
                    filterBy="label"
                    [filter]="true"
                    (onChange)="changeGroup($event, 'table')">
                  </p-dropdown>
                </div>
                <div style="width:10%">
                  <button
                    pButton pRipple
                    type="button"
                    icon="far fa-hand-pointer"
                    [disabled]="!rowData[col.field]"
                    (click)="showTenantMappingUserGroupDetailDialog(rowData[col.field], true)">
                  </button>
                </div>
              </div>
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ 'Common.Button.Required' | translate }}
                </div>
              </small>
            </ng-container>

            <ng-container *ngSwitchCase="'tenant'" class="p-fluid">
              <p-dropdown
                appendTo="body"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="tenantOptionsBySelectedGroup"
                [(ngModel)]="rowData[col.field]"
                (onChange)="changeTenant($event, 'table')">
              </p-dropdown>
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ 'Common.Button.Required' | translate }}
                </div>
              </small>
            </ng-container>

            <ng-container *ngSwitchCase="'orgId'" class="p-fluid">
              <p-dropdown
                appendTo="body"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="orgIdOptionsBySelectedTenant"
                [(ngModel)]="rowData[col.field]"
                (onChange)="updateTenantBySelectedOrg($event)">
              </p-dropdown>
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ 'Common.Button.Required' | translate }}
                </div>
              </small>
            </ng-container>

            <ng-container *ngSwitchCase="'workType'" class="p-fluid">
              <p-dropdown
                appendTo="body"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="workTypeOptionsBySelectedNotifyEvent"
                [(ngModel)]="rowData[col.field]"
                (onChange)="updateNotifyEventBySelectedWorkType($event, 'table')">
              </p-dropdown>
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ 'Common.Button.Required' | translate }}
                </div>
              </small>
            </ng-container>

            <ng-container *ngSwitchCase="'brand'" class="p-fluid">
              <p-multiSelect
                appendTo="body"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="brandOptions"
                [(ngModel)]="rowData[col.field]"
                [virtualScroll]="true"
                [itemSize]="40"
                [showToggleAll]="false"
                (onChange)="updateVendorCategoryByBrand($event)">
                <ng-template pTemplate="selectedItems" let-value>
                  <ng-container *ngIf="value === null ; else showData">
                    <span>
                      {{ 'Common.Message.ChooseOption' | translate }}
                    </span>
                  </ng-container>
                  <ng-template #showData>
                    <span *ngFor="let val of value; first as isFirst">
                      <ng-container *ngIf="!isFirst">, </ng-container>
                      {{ val }}
                    </span>
                  </ng-template>
                </ng-template>
              </p-multiSelect>
            </ng-container>

            <ng-container *ngSwitchCase="'vendorCategory'" class="p-fluid">
              <p-multiSelect
                appendTo="body"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="vendorCategoryOptionsBySelectedBrand"
                [disabled]="rowData['brand'] && rowData['brand'].length > 1"
                [(ngModel)]="rowData[col.field]"
                [virtualScroll]="true"
                [itemSize]="40"
                [showToggleAll]="false">
                <ng-template pTemplate="selectedItems" let-value>
                  <ng-container *ngIf="value === null; else showData">
                    <span>
                      {{ 'Common.Message.ChooseOption' | translate }}
                    </span>
                  </ng-container>
                  <ng-template #showData>
                    <span *ngFor="let val of value; first as isFirst">
                      <ng-container *ngIf="!isFirst">, </ng-container>
                      {{ val }}
                    </span>
                  </ng-template>
                </ng-template>
              </p-multiSelect>
            </ng-container>

            <ng-container *ngSwitchCase="'dept'" class="p-fluid">
              <p-multiSelect
                appendTo="body"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                [options]="deptOptionsByPermission"
                [(ngModel)]="rowData[col.field]"
                [virtualScroll]="true"
                [itemSize]="40"
                [showToggleAll]="false">
                <ng-template pTemplate="selectedItems" let-value>
                  <ng-container *ngIf="value === null ; else showData">
                    <span>
                      {{ 'Common.Message.ChooseOption' | translate }}
                    </span>
                  </ng-container>
                  <ng-template #showData>
                    <span *ngFor="let val of value; first as isFirst">
                      <ng-container *ngIf="!isFirst">, </ng-container>
                      {{ val }}
                    </span>
                  </ng-template>
                </ng-template>
              </p-multiSelect>
            </ng-container>

            <ng-container *ngSwitchCase="'consigneeKey'" class="p-fluid">
              <ng-container *ngIf="showEditConsigneeKeyAndSalesCode(rowData)">
                <laas-customer-dropdown
                  [showToggleAll]="false"
                  [isMultiple]="true"
                  [showLabel]="false"
                  [(ngModel)]="rowData[col.field]">
                </laas-customer-dropdown>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'salesCode'" class="p-fluid">
              <ng-container *ngIf="showEditConsigneeKeyAndSalesCode(rowData)">
                <p-multiSelect
                  appendTo="body"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [filter]="true"
                  [options]="salesOptions"
                  [(ngModel)]="rowData[col.field]"
                  [virtualScroll]="true"
                  [itemSize]="40"
                  [showToggleAll]="false">
                  <ng-template pTemplate="selectedItems" let-value>
                    <ng-container *ngIf="value === null ; else showData">
                      <span>
                        {{ 'Common.Message.ChooseOption' | translate }}
                      </span>
                    </ng-container>
                    <ng-template #showData>
                      <span *ngFor="let val of value; first as isFirst">
                        <ng-container *ngIf="!isFirst">, </ng-container>
                        {{ val }}
                      </span>
                    </ng-template>
                  </ng-template>
                </p-multiSelect>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'isActivated'" class="p-fluid">
              <p-inputSwitch
                class="ml-2"
                [(ngModel)]="rowData.transIsActivated"
                [disabled]="!editPermission"
                (onChange)="changeActivated($event, rowData)">
              </p-inputSwitch>
            </ng-container>

            <ng-container *ngSwitchCase="'updateActivatedUser'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'updateUser'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'createUser'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault class="p-fluid">
              <ng-container [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'" class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date : "yyyy-MM-dd" | replaceNullWith: "-" }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>

        <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'notifyEventGroupKey'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.notifyEventOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'tenantMappingUserGroupSeqNo'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.userGroupOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'tenant'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.tenantOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'orgId'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.orgIdOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'workType'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.workTypeOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'brand'" class="p-fluid">
              <div class="overflow-text">
                <ng-container *ngIf="!rowData['workType']; else showData">
                  -
                </ng-container>
                <ng-template #showData>
                  <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                    ALL
                  </ng-container>
                  <ng-template #showData>
                    {{ rowData[col.field] | optionsMapping: this.brandOptions | replaceNullWith: "ALL" }}
                  </ng-template>
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'vendorCategory'" class="p-fluid">
              <div class="overflow-text">
                <ng-container *ngIf="!rowData['workType']; else showData">
                  -
                </ng-container>
                <ng-template #showData>
                  <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                    ALL
                  </ng-container>
                  <ng-template #showData>
                    {{ rowData[col.field] | optionsMapping: this.vendorCategoryOptions | replaceNullWith: "ALL" }}
                  </ng-template>
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'dept'" class="p-fluid">
              <div class="overflow-text">
                <ng-container *ngIf="!rowData['workType']; else showData">
                  -
                </ng-container>
                <ng-template #showData>
                  <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                    ALL
                  </ng-container>
                  <ng-template #showData>
                    {{ rowData[col.field] | optionsMapping: this.deptOptions | replaceNullWith: "ALL" }}
                  </ng-template>
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'consigneeKey'" class="p-fluid">
              <div class="overflow-text">
                <ng-container *ngIf="rowData['workType'] && (rowData['workType'] === 'COMMON_DELIVERY_ORDER' || rowData['workType'] === 'TENANT_GROUP_TRANSFER_DELIVERY_ORDER'); else showDisableData">
                  <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                    ALL
                  </ng-container>
                  <ng-template #showData>
                    {{ rowData[col.field] | optionsMapping: this.customerOptions | replaceNullWith: "ALL" }}
                  </ng-template>
                </ng-container>
                <ng-template #showDisableData>
                  -
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'salesCode'" class="p-fluid">
              <div class="overflow-text">
                <ng-container *ngIf="rowData['workType'] && (rowData['workType'] === 'COMMON_DELIVERY_ORDER' || rowData['workType'] === 'TENANT_GROUP_TRANSFER_DELIVERY_ORDER'); else showDisableData">
                  <ng-container *ngIf="!rowData[col.field] || rowData[col.field].length === 0; else showData">
                    ALL
                  </ng-container>
                  <ng-template #showData>
                    {{ rowData[col.field] | optionsMapping: this.salesOptions | replaceNullWith: "ALL" }}
                  </ng-template>
                </ng-container>
                <ng-template #showDisableData>
                  -
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'isActivated'" class="p-fluid">
              <p-inputSwitch
                class="ml-2"
                [(ngModel)]="rowData.transIsActivated"
                [disabled]="!editPermission"
                (onChange)="changeActivated($event, rowData)">
              </p-inputSwitch>
            </ng-container>

            <ng-container *ngSwitchCase="'updateActivatedUser'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'updateUser'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'createUser'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: this.userOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault class="p-fluid">
              <ng-container [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'" class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date : "yyyy-MM-dd" | replaceNullWith: "-" }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>

  <laas-tenant-mapping-user-group-detail-dialog
    #tenantMappingUserGroupDetailDialog
    [(visible)]="isShowTenantMappingUserGroupDetail">
  </laas-tenant-mapping-user-group-detail-dialog>
</div>
<help-dock
  [permissionCode]="helpCenterPermissionCode"
  [lang]="currentLang">
</help-dock>
